import { DiveType } from '@ui-kit/MyLink/PropsLink';
import { useRouter } from 'next/router';
import { useAppSelector } from '@redux/hooks';
import classNames from 'classnames';
import IconArrow from '@ui-kit/MyLink/arrow.svg';
import IconShortArrow from '@ui-kit/MyLink/short-arrow.svg';

import styles from './Link.module.scss';

export const LinkBack = ({ appearance, className, disabled, children, color }: DiveType) => {
  const router = useRouter();
  const { showLinkBack } = useAppSelector(state => state.basket.data);
  const handleBackLink = async () => {
    if (showLinkBack) {
      await router.push('/catalog');
    } else {
      router.back();
    }
  };
  return (
    <div
      data-testid="btn-revert-shop"
      onClick={handleBackLink}
      className={classNames(styles.Link, styles[appearance], styles[color], disabled && styles.disabled, className)}
    >
      {appearance === 'theme5' && <IconArrow />}
      {children}
      {appearance === 'theme3' && <IconShortArrow />}
    </div>
  );
};
